module.exports = __webpack_public_path__ + "img/recherche_visiteur.795e3923.png";